import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import { useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {TussenOnsBroadcastCard} from "../../components/tussen-ons/TussenOnsBroadcastCard";
import {Button} from "@jane/lib/src/components/form/Button";
import {usePermissions} from "../../resources/PermissionsHook";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import {NavLink, useNavigate} from "react-router-dom";
import {useMemo} from "react";

export const TussenOnsOverviewPage = () => {
  const {broadcasts: broadcastsApi} = useApiCall(config)
  const {resource: broadcasts, isLoading} = useApiEndpoint(() => broadcastsApi.browseUserBroadcasts())
  const {canManageBroadcasts} = usePermissions()

  const filteredBroadcasts = useMemo(() => {
    return (broadcasts ?? [])
      .filter(b => b.is_unread)
      .sort((a,b) => {
        return b.updated_at.localeCompare(a.updated_at);
      })
      .slice(0,2)
  }, [broadcasts])

  const navigate = useNavigate()

  return <ContentContainer size={'md'}>
    <section className={'mb-16'}>
      <div className={'flex items-start justify-between'}>
        <PageHeader>Nieuws</PageHeader>
        {canManageBroadcasts && <Button type={'primary'} size={'sm'} text={'Nieuws-publicaties Beheren'} onClick={() => navigate(`/broadcasts`)} />}
      </div>
      <div className={'grid grid-cols-1 xl:grid-cols-2 gap-4 mb-4'}>
        {(broadcasts !== undefined && !isLoading) ? <>
          {filteredBroadcasts.length === 0 ? <>
            <div className={'border border-brand-primary-container rounded-lg px-4 py-4 text-brand-secondary flex items-center'}>
              <FontAwesomeIcon icon={faCircleCheck} />
              <div className={'font-medium ml-4'}>
                Er zijn geen ongelezen nieuwsbrieven
              </div>
            </div>
          </> : <></>}
          {filteredBroadcasts.map((b, i) => {
            return <TussenOnsBroadcastCard broadcast={b} unread={b.is_unread ?? false} key={i} />
          })}
          <div>

          </div>
        </> :<TussenOnsBroadcastCard broadcast={null} unread={false} />}
      </div>
      <NavLink to={'/tussen-ons/nieuws'} className={'underline text-brand-primary'}>Oudere berichten bekijken</NavLink>
    </section>
    <PageHeader>Berichten</PageHeader>
    <div>
      Berichten zijn nog niet beschikbaar
    </div>
  </ContentContainer>
}